import { useEffect, useState } from 'react'
import { queryScreenPermission, readScreens } from './window-management'

/**
 * The name of the screen this window is on, for the console's status line -
 * only if the screen permission is granted already: this window never asks.
 */
export const useScreenLabel = (): string | undefined => {
	const [label, setLabel] = useState<string>()
	useEffect(() => {
		let alive = true
		queryScreenPermission()
			.then(({ state }) => (state === 'granted' ? readScreens() : undefined))
			.then(details => {
				if (alive) {
					setLabel(details?.currentScreen.label || undefined)
				}
			})
		return () => {
			alive = false
		}
	}, [])
	return label
}
